import type { ElementRef } from '@angular/core';
import {
	afterRenderEffect,
	Component,
	input,
	model,
	viewChild,
} from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { GeneralHelper } from '@valk-nx/helpers/lib/general/general.helper';
import { SVG_ICON_IMPORTS } from '@valk-nx/helpers/lib/svg-unique-ids/svg-unique-ids.directive';

@Component({
	selector: 'vp-panel',
	templateUrl: './panel.html',
	imports: [SVG_ICON_IMPORTS, TranslatePipe],
})
export class PanelComponent {
	label = input.required<string>();
	closeButton = input(true);

	open = model(false);

	dialogRef = viewChild.required<ElementRef<HTMLDialogElement>>('dialog');

	private scrollPosition = 0;
	private bodyLocked = false;

	constructor() {
		afterRenderEffect(() => {
			const dialog = this.dialogRef().nativeElement;
			const open = this.open();

			if (open && !dialog.open) {
				this.scrollPosition = window.scrollY;
				dialog.showModal();
			} else if (!open && dialog.open) {
				dialog.close();
			}

			this.syncBodyLock(open);
		});
	}

	close() {
		this.open.set(false);
	}

	onCancel(event: Event) {
		event.preventDefault();
		this.close();
	}

	private syncBodyLock(locked: boolean) {
		if (locked === this.bodyLocked) return;

		this.bodyLocked = locked;
		GeneralHelper.bodyLock(locked, this.scrollPosition);
	}
}
